<template>
    <div :class="`row ${marginClass}`">
        <div :class="`col-lg-10 col-md-10 col-sm-12 ${paddingClass} m-auto ${colorClass}`">
            <h5 class="text-dark mb-0" v-if="$slots.title">
                <slot name="title" />
            </h5>

            <small class="text-muted" v-if="$slots.description">
                <slot name="description" />
            </small>

            <slot name="body" />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            colorClass: {
                type: String,
                default: 'bg-form'
            },
            marginClass: {
                type: String,
                default: 'mb-6'
            },
            paddingClass: {
                type: String,
                default: 'px-4 px-md-8 py-8'
            }
        }
    });
</script>
